import {
    BoltRounded,
    DirectionsRunRounded,
    ShutterSpeedRounded,
} from "@mui/icons-material";

export const defaultActivity = {
    duration: 60,
    intensity: "medium",
    mode: "gym",
};

export const exerciseSections = [
    {
        path: "duration",
        title: "Duração",
        icon: ShutterSpeedRounded,
        allowCustom: true,
        customLabel: "Ou, insira uma duração personalizada (em minutos)",
        customPlaceholder: "Duração",
        customMax: 600,
        options: [
            { title: "15 min", value: 15 },
            { title: "30 min", value: 30 },
            { title: "45 min", value: 45 },
            { title: "1h", value: 60 },
        ],
    },
    {
        path: "intensity",
        title: "Intensidade",
        icon: BoltRounded,
        options: [
            { title: "Baixa", value: "low" },
            { title: "Moderada", value: "medium" },
            { title: "Alta", value: "high" },
        ],
    },
    {
        path: "mode",
        title: "Modalidade",
        icon: DirectionsRunRounded,
        options: [
            { title: "Musculação", value: "gym" },
            { title: "Corrida", value: "running" },
            { title: "Ciclismo", value: "cycling" },
            { title: "Caminhada", value: "walking" },
            { title: "Natação", value: "swimming" },
        ],
    },
];
